import React, { Component } from "react";
import { connect } from "react-redux";
import { refreshView as refreshViewAction } from "react-admin";
import NavigationRefresh from "@material-ui/icons/Refresh";

class MyRefresh extends Component {
    componentDidMount() {
        const { refreshInterval, refreshView } = this.props;
        if (refreshInterval) {
            this.interval = setInterval(() => {
                if (this.props.refreshInterval) {
                    refreshView();
                }
            }, refreshInterval);
        }
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        // Now i show no icon because the refresh icon is always available on the appbar
        return <span />;
    }
}

const RefreshButton = connect(
    null,
    { refreshView: refreshViewAction }
)(MyRefresh);

const RefreshListActions = ({
    resource,
    filters,
    displayedFilters,
    filterValues,
    basePath,
    showFilter,
    refreshInterval
}) => (
    <span>
        {filters &&
            React.cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: "button"
            })}
        <RefreshButton
            primary
            label=""
            refreshInterval={refreshInterval}
            icon={<NavigationRefresh />}
        />
    </span>
);

export default RefreshListActions;



// WEBPACK FOOTER //
// ./src/resources/Installations/RefreshListActions.js